module.exports = __webpack_public_path__ + "img/bg05.cdc38cbb.gif";